<p>new-fee-structure works!</p>
